import { render } from "./App.vue?vue&type=template&id=2d914be0"
const script = {}

import "./App.vue?vue&type=style&index=0&id=2d914be0&lang=css"

import exportComponent from "D:\\Work\\TechTrioz Project\\Organization_Git\\Hotel Managment\\hotel_mgmt_fe\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__